import { Progress } from "@/components/ui/progress";

type Props = {
  done: number;
  total: number;
};

export function MilestoneProgressBar({ done, total }: Props) {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return (
    <div className="flex items-center gap-3">
      <Progress value={pct} className="flex-1 max-w-[300px]" />
      <div className="text-sm font-medium tabular-nums">
        {done} / {total}
      </div>
    </div>
  );
}
